import React, { memo, VFC, useState, useEffect, useCallback } from 'react';
import {
  Table,Thead,Tbody,Tr,Th,Td,
  Box,Flex,Center,
  Text,Checkbox,
  Spacer,Select
} from '@chakra-ui/react';
import { issueDetailObj, dictObj, reportObj } from '../../types/issue';
import { PrimaryButton } from '../atoms/button/PrimaryButton';
import { MultiXSText } from '../atoms/text/MyText';
import { IssueDiffDialog } from '../organisms/modal/IssueDiffDialog';

type Props = {
  issueArn: string;
  issueDetailObj: issueDetailObj;
  // setPayerAccountId: (arg:string) => void;
  // setReqType: (arg:string) => void;
  // setBaseHistory: (arg:string) => void;
  // setCompHistory: (arg:string) => void;
};

export const IssueHistory: VFC<Props> = memo((props) => {
  const { issueArn,issueDetailObj } = props;
  const [ issueHistory, setIssueHistory ] = useState<Array<dictObj>>([]);
  const [ issueHistoryNum, setIssueHistoryNum ] = useState(0);
  const [ awsFlag, setAwsFlag ] = useState(false);
  const [ englishFlag, setEnglishFlag ] = useState(false);
  // const [ issueArn, setIssueArn ] = useState("");
  // const [ payerId, setPayerId ] = useState("");
  const [ reportHistory, setReportHistory ] = useState<Array<reportObj>>([]);
  const [ oldNum, setOldNum ] = useState(0);
  const [ newNum, setNewNum ] = useState(0);
  const [ diffDisabled, setDiffDisabled ] = useState(true);
  
  // const [ payerAccountId, setPayerAccountId ] = useState('');
  const [ reqType, setReqType ] = useState('');
  const [ baseHistory, setBaseHistory ] = useState('');
  const [ compHistory, setCompHistory ] = useState('');
  
  useEffect(() => {
    if( issueDetailObj ){
      setIssueHistory(issueDetailObj.desc_list);
      setAwsFlag(issueDetailObj.desc_status ?? false);
      setIssueHistoryNum(issueDetailObj.desc_list.length);
      // setIssueArn(issueDetailObj.health_arn);
      // setPayerId(issueDetailObj.payer_account_id);
      setReportHistory(issueDetailObj.report_list);
      setOldNum(issueDetailObj.old_report_num);
      setNewNum(issueDetailObj.new_report_num);
  // console.log(issueDetailObj.old_report_num,issueDetailObj.new_report_num);
      // 履歴が無い場合は、差分ボタンを非活性
      if( issueDetailObj.old_report_num >= 1 ) {
        setDiffDisabled(false);
      }
    }
  }, [issueDetailObj]);

  // const LineReplace = ({msg}: {msg:string}) => {
  //   console.log(msg);
  //   const texts = msg.split("\n").map((item, index) => {
  //     return (
  //       <React.Fragment key={index}>
  //         { item.match(/\n/) ? <br /> : item }
  //       </React.Fragment>
  //     );
  //   });
  //   return (
  //     <Td>{texts}</Td>
  //   )
  // };
  
  // 差分表示押下
  const onOpenDiff = useCallback((reqType: string) => {
    // setPayerAccountId(payerId ?? '');
    setReqType(reqType ?? '');
    setBaseHistory(String(oldNum));
    setCompHistory(String(newNum));
  }, [oldNum,newNum]);

  // 報数の選択肢を設定
  const createReportOption = (report: reportObj) => {
    return (
      <option key={report.report_num} value={report.report_num}>
        {report.display_item}
      </option>
    )
  };

  // 原文併記押下
  const changeEnglishView = (target: boolean) => {
    setEnglishFlag(target);
  };

  return (
    <>
      {issueDetailObj && (
        <>
        <Box id="issueHistory">
          <Flex alignItems="flex-end" marginBottom="5px">
            <Text fontSize="lg">■履歴（{issueHistoryNum}件）［</Text>
            <Checkbox defaultChecked={englishFlag} onChange={(e) => changeEnglishView(e.target.checked)}>
              原文併記
            </Checkbox>
            <Text fontSize="lg">］</Text>
            <Spacer />
            <Center>
              <Box marginRight="10px">
                <Text>比較元の障害履歴(報数)</Text>
                <Select id="old_report" size="sm" value={oldNum} 
                  onChange={(e) => setOldNum(Number(e.target.value))}>
                  {reportHistory.map((item:reportObj) => (
                    createReportOption(item)
                  ))}
                </Select>
              </Box>
              <Box marginRight="10px">
                <Text>比較先の障害履歴(報数)</Text>
                <Select id="new_report" size="sm" value={newNum} 
                  onChange={(e) => setNewNum(Number(e.target.value))}>
                  {reportHistory.map((item:reportObj) => (
                    createReportOption(item)
                  ))}
                </Select>
              </Box>
              <Box marginRight="10px">
                <PrimaryButton
                  type="ja"
                  size="sm"
                  disabled={diffDisabled}
                  onClick={() => onOpenDiff("1")}>{`日本語訳差分`}</PrimaryButton>
              </Box>
              <Box>
                <PrimaryButton
                  type="en"
                  size="sm"
                  disabled={diffDisabled}
                  onClick={() => onOpenDiff("2")}>{'　'+'原文差分'+'　'}</PrimaryButton>
              </Box>
            </Center>
          </Flex>
          {/* 以下障害グループ詳細リスト */}
          <Table id="table-health-group-detail" border="1" colorScheme="gray" variant="striped" size="sm">
            <Thead background="#aaaaaa">
              <Tr>
              <Th color="white" fontSize="sm">No.</Th>
              {awsFlag && (
              <>
              <Th color="white" fontSize="sm">更新日時</Th>
              <Th color="white" fontSize="sm">状況</Th>
              </>
              )}
              <Th color="white" fontSize="sm">日本語訳</Th>
              {englishFlag && (
                <Th color="white" fontSize="sm">原文</Th>
              )}
            </Tr>
            </Thead>
            <Tbody>
              {issueHistory.map((item:dictObj,index) => (
                <Tr key={index} verticalAlign="top">
                  <Td>{index+1}</Td>
                  {awsFlag && (
                  <>
                  <Td>{item.update_time}</Td>
                  <Td>{item.desc_status}</Td>
                  </>
                  )}
                  <Td><MultiXSText str={item.desc_ja} size="sm" /></Td>
                  {englishFlag && (
                    <Td><MultiXSText str={item.desc_en} size="sm" /></Td>
                  )}
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
        {reqType && (
          <IssueDiffDialog
            issueArn={issueArn}
            // payerAccountId={payerAccountId}
            reqType={reqType}
            baseHistory={baseHistory}
            compHistory={compHistory}
            setReqType={setReqType}
          />
        )}
        </>
      )}
    </>
  );
});
